define([
    'angular',
    './controllers/campaigns',
    './services/campaigns',
    '../site/services/site',
    'angular-ui-router',
], function (angular, campaignsCtrl) {
    'use strict';

    var app = angular
        .module('campaignApp', [
            'campaignServices',
            'ui.router',
            'siteServices',
        ])
        // controllers
        .controller(campaignsCtrl.name, campaignsCtrl.arguments)
        // routes
        .config([
            '$stateProvider',
            '$locationProvider',
            function ($stateProvider, $location) {
                $location.html5Mode({
                    enabled: true,
                    requireBase: false,
                });
                $stateProvider
                    .state('campaigns', {
                        abstract: true,
                    })
                    .state('campaigns.list', {
                        url: Routing.generate('campaigns'),
                        title: 'Campaigns',
                        views: {
                            'body@': {
                                controller: 'campaignsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppCampaign',
                                        entity: 'Campaign',
                                        template: 'partials/list.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('campaigns.create', {
                        url: decodeURIComponent(
                            Routing.generate('create_campaign', {
                                _format: 'html',
                            })
                        ),
                        title: 'Create Campaign',
                        views: {
                            'body@': {
                                controller: 'campaignsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppCampaign',
                                        entity: 'Campaign',
                                        template: 'partials/edit.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('campaigns.send', {
                        url: decodeURIComponent(
                            Routing.generate('send_campaign', {
                                _format: 'html',
                                campaign: ':campaign',
                            })
                        ),
                        title: 'Send Campaign',
                        views: {
                            'body@': {
                                controller: 'campaignsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppCampaign',
                                        entity: 'Campaign',
                                        template: 'partials/send.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('campaigns.sendOneOff', {
                        url: decodeURIComponent(
                            Routing.generate('send_one_off_campaign', {
                                _format: 'html',
                            })
                        ),
                        title: 'Send Campaign',
                        views: {
                            'body@': {
                                controller: 'campaignsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppCampaign',
                                        entity: 'Campaign',
                                        template: 'partials/send.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('campaigns.update', {
                        url: decodeURIComponent(
                            Routing.generate('update_campaign', {
                                _format: 'html',
                                campaign: ':campaign',
                            })
                        ),
                        title: 'Edit Campaign',
                        views: {
                            'body@': {
                                controller: 'campaignsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppCampaign',
                                        entity: 'Campaign',
                                        template: 'partials/edit.html',
                                    }
                                ),
                            },
                        },
                    })
                    .state('campaigns.view', {
                        url: decodeURIComponent(
                            Routing.generate('view_campaign', {
                                _format: 'html',
                                campaign: ':campaign',
                            })
                        ),
                        title: 'Campaign',
                        views: {
                            'body@': {
                                controller: 'campaignsCtrl',
                                templateUrl: Routing.generate(
                                    'angular_partial',
                                    {
                                        bundle: 'AppCampaign',
                                        entity: 'Campaign',
                                        template: 'partials/view.html',
                                    }
                                ),
                            },
                        },
                    });
            },
        ]);
    return app;
});
